// @core/api/endpoints/form/delete_form_submission.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/form';

/**
 * Delete form submission
 * Deletes a form submission and all its answers.
 */
export async function DeleteFormSubmission(
  submission_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/forms/submissions/:submission_id`;
  requestPath = requestPath.replace(':submission_id', encodeURIComponent(submission_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
